module.exports = __webpack_public_path__ + "static/media/Swiss_Medical_Seguros_Logo.19f89cd0.png";